import { render } from "./RegistrationManagement.vue?vue&type=template&id=2ef3f994&scoped=true"
import script from "./RegistrationManagement.vue?vue&type=script&lang=js"
export * from "./RegistrationManagement.vue?vue&type=script&lang=js"

import "./RegistrationManagement.vue?vue&type=style&index=0&id=2ef3f994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef3f994"]])

export default __exports__